module.exports = __webpack_public_path__ + "static/media/article-2.b6ecdb40.png";